export default __webpack_public_path__ + "static/media/survey-design.8072d635.svg";